import { DOG_AGE_STAGE_OPTIONS } from 'root-constants'
import usaNew from 'nove8/assets/images/flags/usa-flag.png'
import au from 'nove8/assets/images/flags/australian-flag.png'
import caNew from 'nove8/assets/images/flags/canada-flag.png'
import uk from 'nove8/assets/images/flags/uk-flag.png'
import br from 'nove8/assets/images/flags/brazilian-flag.png'
import fr from 'nove8/assets/images/flags/france-flag.png'
import de from 'nove8/assets/images/flags/german-flag.png'
import it from 'nove8/assets/images/flags/italian-flag.png'
import mx from 'nove8/assets/images/flags/mexico-flag.png'
import pt from 'nove8/assets/images/flags/portugal-flag.png'
import es from 'nove8/assets/images/flags/spain-flag.png'
import tr from 'nove8/assets/images/flags/turkish-flag.png'
import zeroSixMonths from '../../assets/images/sprite/zeroSixMonths.svg'
import twoFiveYears from '../../assets/images/sprite/twoFiveYears.svg'
import sevenTwelveMonths from '../../assets/images/sprite/sevenTwelveMonths.svg'
import oneTwoYears from '../../assets/images/sprite/oneTwoYears.svg'
import moreThanFiveYears from '../../assets/images/sprite/moreThanFiveYears.svg'
import { TOption } from '../../types'

export const STRESS_ANSWER = 'Stress relief / self-soothing'
export const ATTENTION_ANSWER = 'Attention-seeking'
export const NEVER_ANSWER = 'Never'
export const PUNISHMENT_ANSWER = 'Physical punishment'
export const RAISE_VOICE_ANSWER = 'Raise my voice'
export const YES_ANSWER = 'Yes'
export const SOMETIMES_ANSWER = 'Sometimes'
export const OFTEN_ANSWER = 'Often'
export const ALWAYS_ANSWER = 'Always'
export const NOT_REALLY_ANSWER = 'Not really'
export const IDK = 'I don’t know'

export const AGE_OPTIONS: Array<TOption> = [
  {
    value: DOG_AGE_STAGE_OPTIONS.YOUNGER_THEN_SIX_MONTH,
    image: zeroSixMonths,
    translationKey: 'onboarding.age.youngerThenSixMonth',
    testId: 'quiz-age-under-6m',
  },
  {
    value: DOG_AGE_STAGE_OPTIONS.SIX_TWELVE_MONTHS,
    image: sevenTwelveMonths,
    translationKey: 'onboarding.age.sixTwelveMonth',
    testId: 'quiz-age-6-12m',
  },
  {
    value: DOG_AGE_STAGE_OPTIONS.ONE_TWO_YEAR,
    image: oneTwoYears,
    translationKey: 'onboarding.age.oneTwoYear',
    testId: 'quiz-age-1-2y',
  },
  {
    value: DOG_AGE_STAGE_OPTIONS.TWO_SEVEN_YEARS,
    image: twoFiveYears,
    translationKey: 'onboarding.age.twoSevenYears',
    testId: 'quiz-age-2-7y',
  },
  {
    value: DOG_AGE_STAGE_OPTIONS.MORE_THAN_SEVEN_YEARS,
    image: moreThanFiveYears,
    translationKey: 'onboarding.age.moreThanSevenYears',
    testId: 'quiz-age-over-7y',
  },
]

export const enum DogsBreed {
  MIXED_BREED = 'Mixed Breed',
  GOLDEN_RETRIEVER = 'Golden Retriever',
  LABRADOR_RETRIEVER = 'Labrador Retriever',
  DACHSHUND = 'Dachshund',
  GERMAN_SHEPHERD = 'German Shepherd',
  FRENCH_BULLDOG = 'French Bulldog',
  AMERICAN_PIT_BULL_TERRIER = 'American Pit Bull Terrier',
  CHIHUAHUA = 'Chihuahua',
  BORDER_COLLIE = 'Border Collie',
  BEAGLE = 'Beagle',
  SIBERIAN_HUSKY = 'Siberian Husky',
  YORKSHIRE_TERRIER = 'Yorkshire Terrier',
  SHIH_TZU = 'Shih Tzu',
  POODLE = 'Poodle',
  GOLDENDOODLE = 'Goldendoodle',
  AU_SHEPHERD = 'Australian Shepherd',
  COCKAPOO = 'Cockapoo',
  CAVAPOO = 'Cavapoo',
  MALTIPOO = 'Maltipoo',
  TERRIER = 'Jack Russell Terrier',
  POMERANIAN = 'Pomeranian',
}

export const MAX_LEVEL = 10

export const PROGRESS_MARKERS = ['extremlyLow', 'low', 'medium', 'high']

export const REACTIVITY_VALUE = {
  2: {
    text: 'Extremely low',
    key: 'extremlyLow',
    textColor: '#EC544A',
    tooltipPosition: 'calc(15% - 38px)',
    talePosition: 'calc(50% - 8px)',
  },
  3: {
    text: 'Low',
    key: 'low',
    textColor: '#EC544A',
    tooltipPosition: 'calc(20% - 38px)',
    talePosition: 'calc(50% - 8px)',
  },
  4: {
    text: 'Low',
    key: 'low',
    textColor: '#F5875B',
    tooltipPosition: 'calc(35% - 28px)',
    talePosition: 'calc(50% - 8px)',
  },
  5: {
    text: 'Low',
    key: 'low',
    textColor: '#F5875B',
    tooltipPosition: 'calc(35% - 38px)',
    talePosition: 'calc(50% - 8px)',
  },
  6: {
    text: 'Medium',
    key: 'medium',
    textColor: '#A8C95E',
    tooltipPosition: 'calc(45% - 38px)',
    talePosition: 'calc(50% - 8px)',
  },
  7: {
    text: 'Medium',
    key: 'medium',
    textColor: '#A8C95E',
    tooltipPosition: 'calc(55% - 38px)',
    talePosition: 'calc(50% - 8px)',
  },
  8: {
    text: 'Medium',
    key: 'medium',
    textColor: '#A8C95E',
    tooltipPosition: 'calc(75% - 38px)',
    talePosition: 'calc(50% - 8px)',
  },
  9: {
    text: 'High',
    key: 'high',
    textColor: '#39C544',
    tooltipPosition: 'calc(85% - 38px)',
    talePosition: 'calc(50% - 8px)',
  },
  10: {
    text: 'High',
    key: 'high',
    textColor: '#39C544',
    tooltipPosition: 'calc(95% - 38px)',
    talePosition: 'calc(50% - 8px)',
  },
}

export const COMMENTS = {
  en: [
    {
      title: 'onboarding.prepareFlow.reviews.item15.title',
      text: 'onboarding.prepareFlow.reviews.item15.text',
      avatar: usaNew,
      autor: 'Kvkerns',
    },
    {
      title: 'onboarding.prepareFlow.reviews.item16.title',
      text: 'onboarding.prepareFlow.reviews.item16.text',
      avatar: usaNew,
      autor: 'Itsurgirlalexandraa',
    },
    {
      title: 'onboarding.prepareFlow.reviews.item17.title',
      text: 'onboarding.prepareFlow.reviews.item17.text',
      avatar: usaNew,
      autor: 'Fast change',
    },
    {
      title: 'onboarding.prepareFlow.reviews.item18.title',
      text: 'onboarding.prepareFlow.reviews.item18.text',
      avatar: uk,
      autor: 'Springle 54',
    },
    {
      title: 'onboarding.prepareFlow.reviews.item12.title',
      text: 'onboarding.prepareFlow.reviews.item12.text',
      avatar: uk,
      autor: 'BEST TO TRAIN WITH',
    },
    {
      title: 'onboarding.prepareFlow.reviews.item13.title',
      text: 'onboarding.prepareFlow.reviews.item13.text',
      avatar: caNew,
      autor: 'Lilfries01',
    },
    {
      title: 'onboarding.prepareFlow.reviews.item14.title',
      text: 'onboarding.prepareFlow.reviews.item14.text',
      avatar: au,
      autor: 'Anthony0281',
    },
  ],
  es: [
    {
      title: 'Increíble',
      text: 'Es una aplicación que te ayuda a ti y a tu perro',
      avatar: mx,
      autor: 'en todo problemas',
    },
    {
      title: 'Excelente App',
      text:
        'La aplicación es muy útil, fácil, y sencilla de aplicar; solo requiere mucha paciencia y constancia para tener excelentes resultados!!!',
      avatar: mx,
      autor: 'Me greenh',
    },
    {
      title: 'App de entrenamiento',
      text: 'Bien pensada',
      avatar: es,
      autor: 'superrr buena aplicacion',
    },
    {
      title: 'Les agradezco mucho',
      text: 'Gracias a ellos mi perro ya se sabe comportar',
      avatar: mx,
      autor: 'Emiliano paz',
    },
    {
      title: 'Excelente',
      text:
        'Me gusta l forma que se explica la forma de planificar las rutinas de mi perro',
      avatar: mx,
      autor: 'princesa galleta',
    },
    {
      title: 'Muy buena',
      text: 'Cómodo fácil y con bastantes niveles',
      avatar: es,
      autor: 'JmSSHH',
    },
    {
      title: 'Muy buena',
      text:
        'Con esta app entrénate a mi primer perro y ahora con el nuevo la voy a utilizar',
      avatar: mx,
      autor: 'Sofía mamá de gaia',
    },
  ],
  pt: [
    {
      title: 'Amei',
      text: 'Minha cachorra aprendeu tudo',
      avatar: br,
      autor: 'valentinaguimama',
    },
    {
      title: 'Avaliação',
      text:
        'Muito satisfatório esse app, pois tem a disposição de ensinar como adestrar um Pet, que é um pouco complicado, mas com o app tudo ficou mais fácil, e divertido',
      avatar: br,
      autor: 'Luninha ☀️🤍🌊🐚',
    },
    {
      title: 'Adoro',
      text: 'Guia muito prático e com bastante informação, estou a adorar',
      avatar: pt,
      autor: 'DigazM',
    },
    {
      title: 'Adestramento',
      text: 'Muito bom, de fácil compreensão',
      avatar: br,
      autor: 'Lucinha do roque',
    },
    {
      title: 'Muito bommm',
      text: 'Amando esse app, está nos ensinando muito',
      avatar: br,
      autor: 'Limonena1203',
    },
    {
      title: 'Início',
      text: 'Por enquanto estou gostando',
      avatar: pt,
      autor: 'Arthurtavaresd',
    },
    {
      title: 'Excepcional',
      text:
        'Esse app me trouxe mais tranquilidade e esperança de que meu cachorro resgatado irá se adaptar conosco. Obter informação é o primeiro passo para uma adestraemento consciente e responsável!',
      avatar: br,
      autor: 'Carvalhaes, J.',
    },
  ],
  de: [
    {
      title: 'Super',
      text: 'Bin begeistert..',
      avatar: de,
      autor: 'LottaLenie',
    },
    {
      title: 'Toll erklärt',
      text:
        'Also habe es ebend Instaliert und finde es schon toll und lehrreich',
      avatar: de,
      autor: 'Aisel88',
    },
    {
      title: 'Es ist super',
      text:
        'Es hat mir sehr gefallen! Sehr hilfreich für mich und meine kleine Welpe ❤️',
      avatar: de,
      autor: 'Nasiaar',
    },
    {
      title: 'Super und sehr innovativ',
      text: 'Sehr hilfreich und super innovativ',
      avatar: de,
      autor: 'Kuckilucki',
    },
    {
      title: 'Sehr gut',
      text: 'Unfassbar niedlich gestaltete App',
      avatar: de,
      autor: 'kiralga',
    },
  ],
  fr: [
    {
      title: 'Super application',
      text:
        'Je débute avec l’application mais première vue c’est intéressant A recommander',
      avatar: fr,
      autor: 'mai6868',
    },
    {
      title: 'Super 👍',
      text:
        'Je viens d’avoir un chien ça fait 1 an que je l’ai et cette appli super bien elle n’est pas payante pas comme toutes les autres qui le sont parfois Je la recommande',
      avatar: fr,
      autor: 'irmajules',
    },
    {
      title: 'Incroyable',
      text:
        'L’application est vraiment super on apprend pas mal de chose merci beaucoup',
      avatar: fr,
      autor: 'Femme_Fantome',
    },
    {
      title: 'Note',
      text: 'Incroyable 🤩',
      avatar: fr,
      autor: 'Inconu',
    },
    {
      title: 'Application très bien faite',
      text:
        'Belle application avec de belles images et surtout de très bons conseils',
      avatar: fr,
      autor: '"cococycy7372',
    },
    {
      title: 'Incroyable appli !',
      text:
        'C’est l’une des applications les plus utiles et bien expliquées que je connaisse ! Très diverses et aimante envers les animaux j’adore !',
      avatar: fr,
      autor: '"majaa_neum',
    },
    {
      title: 'Super application',
      text:
        'Super application. Vraiment très bonne application et très ludique c’est très chouette !',
      avatar: fr,
      autor: '"Charliboux',
    },
  ],
  tr: [
    {
      title: 'Tatli eglenceli ve goze hitap eden💖',
      text: 'Ilk defa bir uygulamaya yorum yaziyorum. Emeginize saglik💖',
      avatar: tr,
      autor: 'nihanka1',
    },
    {
      title: 'İndirin canlarıımm ❤️❤️',
      text:
        'Çok güzel köpeğim artık yere işemiyor,eğer köpeğiniz yoksa veya sahiplenmek istiyorsanız da işinize yarayacaktır ❤️❤️',
      avatar: tr,
      autor: 'Kitty 3444',
    },
    {
      title: 'HERKESE tavsiye ederim veterinerim önerdi çok saolun',
      text:
        'Mükemmel ve parasız ilk başta sol üstte çapıya basıp kullanabilirsiniz mükemmel',
      avatar: tr,
      autor: 'Lila MALTİPO',
    },
    {
      title: 'Çok güzel',
      text: 'Dünyanın en tatlı uygulaması falan bu sanırım',
      avatar: tr,
      autor: 'Budıbudu',
    },
    {
      title: 'İyi',
      text: 'Çok iyi bir uygulam tavsiye ederim',
      avatar: tr,
      autor: 'Kızılaurat',
    },
  ],
  it: [
    {
      title: 'Inaspettatamente',
      text:
        'Mi è utilissima dispensa consigli molto efficaci e per me è molto valida ! Con il mio cane funziona benissimo',
      avatar: it,
      autor: 'bilashvji',
    },
    {
      title: '5 stelle',
      text:
        'Un app molto utile per chi vuole fare l’addestratore o nel mio caso l’addestratrice di cani nel futuro ə molto utile',
      avatar: it,
      autor: 'Gianfranca145',
    },
    {
      title: 'Woofz',
      text: 'Ottima app',
      avatar: it,
      autor: '"Tittipagni',
    },
    {
      title: 'Utile',
      text: 'Molto interessante e completa',
      avatar: it,
      autor: '"barabbabarbi',
    },
    {
      title: 'Casa',
      text: 'Mi piace seguire i vostri consigli',
      avatar: it,
      autor: '"Nicholin43',
    },
    {
      title: 'Me gusta mucho !! ',
      text: 'Me gusta',
      avatar: it,
      autor: '"franci.pnz',
    },
  ],
}
